import { PipeTransform, Injectable, Pipe } from '@angular/core';
import { UploadedFileInfo } from "../app/app.interfaces";
import { UploadedFile } from "../app/app.models";

@Pipe({
  name: 'fileUrl'
})
@Injectable()
export class FileUrlPipe implements PipeTransform {

  constructor() {
  }
    
  public transform(input: UploadedFileInfo): string {
    
    if(input===null) return '';
    
    let file = UploadedFile.createFromUploadedFileInfo(input);
    return file.url;


  }
}



// WEBPACK FOOTER //
// ./src/pipes/fileUrl.ts